import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import { enqueueSnackbar } from "notistack";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const withdrawalEndpoint = "transaction/admin/withdrawal";
const { REACT_APP_ACCOUNTS_API_URL } = process.env;

export default function Withdrawal({ accountNum }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const axios = useAxiosPrivate();
  const withdrawal = (e) => {
    setOpen(false);
    const data = new FormData(e.currentTarget);
    e.preventDefault();

    const amount = data.get("amount");
    const narration = data.get("narration");
    const currency = data.get("currency");

    axios
      .post(`${REACT_APP_ACCOUNTS_API_URL}/${withdrawalEndpoint}`, {
        account_number: accountNum,
        amount,
        narration,
        currency,
      })
      .then((res) => {
        if (res.status && res.status === 200) {
          return enqueueSnackbar(`Withdrawal successful`, {
            variant: "success",
          });
        }
      })
      .catch((err) => {
        return enqueueSnackbar(`${err.response.data.apiErrors[0].cause}`, {
          variant: "error",
        });
      });
  };

  return (
    <Grid
      item
      xs={12}
      lg={12}
      md={12}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Paper>
        <div>
          <Button
            onClick={handleOpen}
            startIcon={<SystemUpdateAltIcon />}
          ></Button>
          <Modal
            aria-labelledby="transfer-modal"
            aria-describedby="Transfer funds to another account"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                <Typography
                  id="transfer-form"
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Enter Details
                </Typography>

                <Box
                  mt={2}
                  sx={{
                    m: 1,
                    width: 500,
                    maxWidth: "100%",
                  }}
                  component="form"
                  onSubmit={withdrawal}
                >
                  <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        label="Amount"
                        id="amount"
                        name="amount"
                        type="number"
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        label="Narration"
                        id="narration"
                        name="narration"
                        type="text"
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        required
                        fullWidth
                        label="Currency"
                        id="currency"
                        name="currency"
                        defaultValue={"ZMW"}
                        type="text"
                      />
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        startIcon={<SystemUpdateAltIcon />}
                      >
                        Withdraw
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Fade>
          </Modal>
        </div>
      </Paper>
    </Grid>
  );
}
